import { observable, decorate } from 'mobx';
import _ from 'lodash';

import { DateUtils } from '../dictionary';

/** Модель списка рабочих дней */
export class WorkDays {
	constructor(item) {
		const items = _.isArray(item) ? item : item && item.WorkDays ? item.WorkDays : [];

		this.List = _.map(DateUtils.getFullWeek(), (weekDay) => {
			const day = _.find(items, { Day : weekDay.Id });

			return new WorkDay(_.extend({
				Day : day ? weekDay.Id : -1,
				Name : weekDay.Name
			}, day));
		});
	}

	/**
	 * Установить рабочие дни
	 * @param {string} type тип пресета: все дни или только будни
	 */
	setDays(type) {
		if (/all/.test(type))
			_.each(DateUtils.getFullWeekIndex(), (i) => { this.List[i].collect("Day", true, i); });

		if (/work/.test(type)) {
			_.each(DateUtils.getFullWeekIndex(), (i) => { this.List[i].collect("Day", false, i); });
			_.each(DateUtils.getWorkWeekIndex(), (i) => { this.List[i].collect("Day", true, i); });
		}
	}

	/** Установить рабочее время первого дня по всем выбранным дням */
	setHours = () => {
		if (_.isEmpty(this.List) || this.List[0].Day === -1 || this.List[0].Day === "") return;

		const time = {
			StartTime : this.List[0].StartTime,
			EndTime : this.List[0].EndTime
		};

		_.each(_.filter(this.List, (day) => day.Day !== -1 && day.Day !== ""), (day) => {
			day.collect("Time", time);
		});
	}

	/**
	 * Формирование списка заполненных рабочих дней
	 * @returns {object[]} список рабочих дней
	 */
	getData() {
		return _.map(_.filter(this.List, (day) => {
			return day.Day !== -1 && day.Day !== "" &&
				day.StartTime !== "" && day.EndTime !== "";
		}), (day) => day.getData());
	}
}
decorate(WorkDays, {
	List: observable
});

/** Модель рабочего дня */
export class WorkDay {
	constructor(item) {
		this.Id = item && !_.isUndefined(item.Id) ? item.Id : -1;
		this.Name = item && item.Name ? item.Name : "";
		this.Day = item && !_.isUndefined(item.Day) ? item.Day : -1;
		this.StartTime = item && item.StartTime ? item.StartTime : "";
		this.EndTime = item && item.EndTime ? item.EndTime : "";
	}

	/**
	 * Сбор данных рабочего дня с формы
	 * @param {string} id название параметра
	 * @param {boolean|object} value значение параметра
	 * @param {number} index порядковый номер дня недели
	 */
	collect(id, value, index) {
		if (/Time/.test(id)) {
			this.StartTime = value.StartTime;
			this.EndTime = value.EndTime;
		} else this.Day = value ? index : -1;
	}

	/**
	 * Формирование данных рабочего дня
	 * @returns {object} данные рабочего дня
	 */
	getData() {
		return {
			Id: this.Id,
			Day: this.Day,
			StartTime: this.StartTime,
			EndTime: this.EndTime
		};
	}
}
decorate(WorkDay, {
	Day: observable,
	StartTime: observable,
	EndTime: observable
});
